/*
 * @Descripttion:
 * @Author: lcf
 * @Date: 2022-04-29 17:28:27
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-05-23 09:29:53
 */
/*
 * @Author: zhangshengwei
 */
/*
 * @Author: zhangshengwei
 */

// 封装axios
import axios from 'axios';
import store from '../store'
import {
  Message
} from 'element-ui'

function getUrlParam(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  if (window.location.hash.indexOf("?") < 0) {
    return null;
  }
  let r = window.location.hash.split("?")[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
let MsgObj = null
let Token = getUrlParam("token");
if (Token) {
  sessionStorage.setItem("token", Token);
}
if (sessionStorage.getItem("token")) {
  Token = sessionStorage.getItem("token")
}
const server = axios.create({});
// request 拦截器
server.interceptors.request.use(

  config => {
    // console.log(store.getters.getactiveRegionObj,config)
    if (config.method === "get") {
      if (!config.params) {
        config.params = {}
      }
      if (typeof config.data === 'string') {
        config.params = JSON.parse(config.data)
      }
      if (!config.params.createAreaCode) {
        config.params.createAreaCode = store.getters.getactiveRegionObj.areaCode
      }

    } else {
      if (!config.data.createAreaCode) {
        config.data.createAreaCode = store.getters.getactiveRegionObj.areaCode
      }

    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// response 拦截器
server.interceptors.response.use(
  response => {

    if (response.data.code === 401) {
      if (!MsgObj) {
        MsgObj = Message.error(response.data.msg)
      } else {
        MsgObj.close()
        MsgObj = Message.error(response.data.msg)
      }
      return Promise.reject(response);
      sessionStorage.removeItem("token")
      throw new Error("nework error");
    } else if (response.data.code === 500) {
      if (!MsgObj) {
        MsgObj = Message.error(response.data.msg)
      } else {
        MsgObj.close()
        MsgObj = Message.error(response.data.msg)
      }
      return Promise.reject(response);
      throw new Error("nework error");

    } else {
      // 某些接口的数据不在 response.data.data 里，而在上层的 response.data 里
      if (response.config && response.config.params && response.config.params._unpack) {
        return response.data;
      }
      return response.data.data;
    }

  },
  error => {
    return Promise.reject(error);
  }
);
server.defaults.baseURL = '/prod-api/largescreen';
server.defaults.timeout = 30000;

// 设置请求头，请求数据格式为JSON
server.defaults.headers = {
  'Content-Type': 'application/json;',
  'X-Requested-With': 'XMLHttpRequest',
  'Authorization': 'Bearer ' + Token
};

function callback(res, resolve, reject) {
  resolve(res);
}

function error(err, resolve, reject) {
  reject(err);
}
export default {
  // get请求
  get(url, param) {
    let URL = url;
    return new Promise((resolve, reject) => {
      server({
          method: 'get',
          url: URL,
          data: JSON.stringify(param) || {}
        })
        .then(res => callback(res, resolve, reject))
        .catch(err => error(err, resolve, reject));
    });
  },
  // post请求
  post(url, param) {
    let URL = url;
    return new Promise((resolve, reject) => {
      server({
          method: 'post',
          url: URL,
          data: param || {}
        })
        .then(res => callback(res, resolve, reject))
        .catch(err => error(err, resolve, reject));
    });
  }
};

export const request = server;